import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const SuggestOrganization = lazy (() => import('./SuggestOrganization.jsx'))     

const SuggestOrganizationRoutes = [
    {
        path: '/SuggestOrganization',
        component: SuggestOrganization,
        auth: authRoleAccess.suggest_organization,
    },
   
]

export default SuggestOrganizationRoutes 